export default "__VITE_ASSET__09a76c87__"